
import React from 'react';
import { AlertCircle, AlertTriangle, CheckCircle } from 'lucide-react';
import { MaintenanceAlertData } from '../types/maintenanceTypes';
import MaintenanceAlertCard from './MaintenanceAlertCard';
import { Separator } from '@/components/ui/separator';

interface AlertsGroupSectionProps {
  title: 'Critical Alerts' | 'Medium Alerts' | 'Low Alerts';
  alerts: MaintenanceAlertData[];
  showSeparator?: boolean;
}

const AlertsGroupSection: React.FC<AlertsGroupSectionProps> = ({ 
  title, 
  alerts,
  showSeparator = true
}) => {
  if (alerts.length === 0) return null;

  // Determine icon based on section title
  const icon = title === 'Critical Alerts' ? 
    <AlertCircle className="h-5 w-5 text-red-500" /> :
    title === 'Medium Alerts' ? 
    <AlertTriangle className="h-5 w-5 text-amber-500" /> :
    <CheckCircle className="h-5 w-5 text-emerald-500" />;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        {icon}
        <h3 className="text-lg font-medium">{title}</h3>
      </div>
      
      {alerts.map((alert, index) => (
        <MaintenanceAlertCard 
          key={`${alert.deviceId}-${index}`} 
          alert={alert} 
          index={index} 
        />
      ))}
      
      {showSeparator && <Separator className="my-6" />}
    </div>
  );
};

export default AlertsGroupSection;
